export function renderExclusiveDateUpperBoundHelper(): string {
  return `function getExclusiveDateUpperBound(value?: string): string | null {
  if (!value) return null

  const date = new Date(\`\${value}T00:00:00.000Z\`)
  if (Number.isNaN(date.getTime())) return null

  date.setUTCDate(date.getUTCDate() + 1)
  return date.toISOString().slice(0, 10)
}`
}
